"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The MediaOneToMenyReferences model module.
 * @module model/MediaOneToMenyReferences
 * @version 1.1.3-alpha.1
 */
class MediaOneToMenyReferences {
  /**
   * Constructs a new <code>MediaOneToMenyReferences</code>.
   * @alias module:model/MediaOneToMenyReferences
   */
  constructor() {
    MediaOneToMenyReferences.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>MediaOneToMenyReferences</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MediaOneToMenyReferences} obj Optional instance to populate.
   * @return {module:model/MediaOneToMenyReferences} The populated <code>MediaOneToMenyReferences</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MediaOneToMenyReferences();
      if (data.hasOwnProperty('industry_ids')) {
        obj['industry_ids'] = _ApiClient.default.convertToType(data['industry_ids'], ['String']);
      }
      if (data.hasOwnProperty('category_ids')) {
        obj['category_ids'] = _ApiClient.default.convertToType(data['category_ids'], ['String']);
      }
      if (data.hasOwnProperty('subscription_type_ids')) {
        obj['subscription_type_ids'] = _ApiClient.default.convertToType(data['subscription_type_ids'], ['String']);
      }
      if (data.hasOwnProperty('tag_ids')) {
        obj['tag_ids'] = _ApiClient.default.convertToType(data['tag_ids'], ['Number']);
      }
      if (data.hasOwnProperty('available_in_country_ids')) {
        obj['available_in_country_ids'] = _ApiClient.default.convertToType(data['available_in_country_ids'], ['String']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>MediaOneToMenyReferences</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MediaOneToMenyReferences</code>.
   */
  static validateJSON(data) {
    // ensure the json data is an array
    if (!Array.isArray(data['industry_ids'])) {
      throw new Error("Expected the field `industry_ids` to be an array in the JSON data but got " + data['industry_ids']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['category_ids'])) {
      throw new Error("Expected the field `category_ids` to be an array in the JSON data but got " + data['category_ids']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['subscription_type_ids'])) {
      throw new Error("Expected the field `subscription_type_ids` to be an array in the JSON data but got " + data['subscription_type_ids']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['tag_ids'])) {
      throw new Error("Expected the field `tag_ids` to be an array in the JSON data but got " + data['tag_ids']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['available_in_country_ids'])) {
      throw new Error("Expected the field `available_in_country_ids` to be an array in the JSON data but got " + data['available_in_country_ids']);
    }
    return true;
  }
}

/**
 * @member {Array.<String>} industry_ids
 */
MediaOneToMenyReferences.prototype['industry_ids'] = undefined;

/**
 * @member {Array.<String>} category_ids
 */
MediaOneToMenyReferences.prototype['category_ids'] = undefined;

/**
 * @member {Array.<String>} subscription_type_ids
 */
MediaOneToMenyReferences.prototype['subscription_type_ids'] = undefined;

/**
 * @member {Array.<Number>} tag_ids
 */
MediaOneToMenyReferences.prototype['tag_ids'] = undefined;

/**
 * @member {Array.<String>} available_in_country_ids
 */
MediaOneToMenyReferences.prototype['available_in_country_ids'] = undefined;
var _default = MediaOneToMenyReferences;
exports.default = _default;